
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream/[id]",
      function () {
        return require("private-next-pages/stream/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream/[id]"])
      });
    }
  